import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../../../../services/toast.service';
import { DepositoResponsavel } from '../../../../../../types/DepositoResponsavel.type';
import { DepositoResponsavelService } from '../deposito-responsavel.service';

@Component({
  selector: 'app-deposito-responsavel-form',
  templateUrl: './deposito-responsavel-form.component.html',
  styleUrl: './deposito-responsavel-form.component.css'
})
export class DepositoResponsavelFormComponent implements OnInit {

  registro: DepositoResponsavel = {} as DepositoResponsavel;
  enviado: boolean = false;

  constructor(
    private service: DepositoResponsavelService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if (id) {
      this.service.getAll(0, 1, 'id', 'asc').subscribe({
        next: () => {},
        error: () => {}
      });

      this.service.getAll(0, 9999, 'id', 'asc').subscribe({
        next: (data) => {
          const found = data.content.find(r => r.id === Number(id));
          if (found) {
            this.registro = found;
          } else {
            this.toastService.erro('Erro', 'Registro não encontrado');
            this.router.navigate(['integracoes', 'movimentacoes', 'transferencia-insumos', 'deposito-responsavel']);
          }
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao buscar o registro: ' + (error.error?.message || error.error));
        }
      });
    }
  }

  salvar() {
    this.enviado = true;

    if (this.enviado && this.registro.codigoFuncionario?.trim() && this.registro.codigoDepositoOrigem?.trim() && this.registro.codigoDepositoDestino?.trim()) {
      if (this.registro.id) {
        this.service.put(this.registro.id, this.registro).subscribe({
          next: () => {
            this.toastService.sucesso('Atualização', 'Atualização efetuada com sucesso.');
            this.router.navigate(['integracoes', 'movimentacoes', 'transferencia-insumos', 'deposito-responsavel']);
          },
          error: (error) => {
            this.toastService.erro('Erro', 'Erro ao atualizar: ' + (error.error?.message || error.error));
          }
        });
      } else {
        this.service.post(this.registro).subscribe({
          next: () => {
            this.toastService.sucesso('Cadastro', 'Cadastro efetuado com sucesso.');
            this.router.navigate(['integracoes', 'movimentacoes', 'transferencia-insumos', 'deposito-responsavel']);
          },
          error: (error) => {
            this.toastService.erro('Erro', 'Erro ao cadastrar: ' + (error.error?.message || error.error));
          }
        });
      }
    }
  }
}
